import "./Footer.scss";

export default function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className='footerFormat'>

            <div className='footerFormat'>
                <p>
                    Copyright &copy; {currentYear} Jasmine Rhose Foundation
                </p>
            </div>
        </footer>
    )

}